import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SHARE_URL = 'https://petechtor.org';

export const ShareButtons = () => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(SHARE_URL);
  const encodedMessage = encodeURIComponent(t('shareMessage'));

  const links = [
    { name: 'X', icon: <XIcon className="w-3.5 h-3.5" />, href: `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}` },
    { name: 'Facebook', icon: null, href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { name: 'WhatsApp', icon: null, href: `https://wa.me/?text=${encodedMessage}%20${encodedUrl}` }
  ];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SHARE_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.warn('Clipboard write failed:', err);
    }
  };

  return (
    <div data-testid="share-buttons">
      <p className="text-xs text-slate-500 mb-2">{t('shareInviteLabel')}</p>
      <div className="flex items-center gap-2 flex-wrap">
        {links.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`share-${link.name.toLowerCase()}-btn`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-800/50 border border-slate-700/50 text-slate-300 hover:border-slate-500 hover:text-white transition-colors"
          >
            {link.icon}
            {link.name}
          </a>
        ))}
        <button
          type="button"
          onClick={handleCopy}
          data-testid="share-copy-link-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-800/50 border border-slate-700/50 text-slate-300 hover:border-slate-500 hover:text-white transition-colors"
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? t('shareCopied') : t('shareCopyLink')}
        </button>
      </div>
    </div>
  );
};
